import { Button, Form, Modal } from "antd";
import React, { useState } from "react";
import { svg } from "../../../../Assets/svg";
import { useAppDispatch } from "../../../../store";
import { updateQuotatioStatusAPI } from "../quotationApis";
import { setQuotationDetails } from "../quotationSlice";
import { renderFormLabel } from "../../../../Components/Components";
import TextArea from "antd/es/input/TextArea";
import { ref } from "yup";

interface Props {
  open: boolean;
  onClose: () => void;
  quote_id: string;
  refreshData?: (data: any) => void;
}

const AddApprovalOverrideNoteModal: React.FC<Props> = ({
  open,
  onClose,
  quote_id,
  refreshData,
}) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const onFinish = (values: any) => {
    setSaving(true);

    dispatch(
      updateQuotatioStatusAPI({
        payload: {
          quote_id: quote_id,
          status: "approved_override",
          approval_note: values.note,
        },
        onSuccess: (data) => {
          refreshData?.(data);
          setSaving(false);
          onClose();
        },
        onError: () => {
          setSaving(false);
        },
      }),
    );
  };

  return (
    <Modal
      centered
      open={open}
      onCancel={onClose}
      footer={null}
      closeIcon={svg?.closeIcon}
      width="36rem"
      className="commonModalClass"
      destroyOnClose={true}
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          Approval Override, Are You Sure?
        </div>
      }
    >
      <p className="text-center text-secondary mb-4">
        Using approval override will bypass the standard approval process and
        mark this request as approved. Please add approval notes and confirm
        before proceeding.
      </p>

      <Form
        layout="vertical"
        form={form}
        className="page-form"
        onFinish={onFinish}
        initialValues={{ note: "" }}
      >
        <Form.Item
          label={renderFormLabel("Approval Notes", false)}
          name="note"
          rules={[
            { required: true, message: "Note is required" },
            // ✅ VALIDATION: Prevents inputs that are just empty spaces
            { whitespace: true, message: "Note cannot be empty" },
          ]}
          required={false}
        >
          <TextArea
            placeholder="Enter Approval Notes"
            className="form-control mt-2 py-3 bg-white"
            rows={5}
          />
        </Form.Item>

        <div className="d-flex justify-content-center gap-3 mt-4">
          <Button
            className="btn btn-lg btn-outline-secondary h-auto px-5"
            onClick={onClose}
            disabled={saving}
          >
            CLOSE
          </Button>
          <Button
            htmlType="submit"
            loading={saving}
            className="btn btn-lg btn-primary h-auto px-5"
          >
            APPROVE
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddApprovalOverrideNoteModal;
